/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_SecurityInputs */

const en_cc_security = /** @type {(inputs: Cc_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A link does not grant access. Attendees must still meet KerjaBareng meeting permissions. Access is checked again before transfer and when joining.`)
};

const id_cc_security = /** @type {(inputs: Cc_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan tidak memberikan hak akses. Peserta tetap harus memenuhi izin meeting KerjaBareng. Perubahan hak akses diperiksa kembali sebelum transfer dan saat bergabung.`)
};

/**
* | output |
* | --- |
* | "A link does not grant access. Attendees must still meet KerjaBareng meeting permissions. Access is checked again before transfer and when joining." |
*
* @param {Cc_SecurityInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_security = /** @type {((inputs?: Cc_SecurityInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_SecurityInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_security(inputs)
	return en_cc_security(inputs)
});